module.exports = __webpack_public_path__ + "img/icon-5.f7613ff1.png";